import { observer } from 'mobx-react-lite'
import { type FC } from 'react'
import { Alert } from 'shared/ui'
import { type ContactCreateModalStore } from 'widgets/ContactCreateModal'

type IModalAlertProps = {
  contactCreateModalStore: ContactCreateModalStore
}

export const ContactCreateModalAlert: FC<IModalAlertProps> = observer(
  ({ contactCreateModalStore }) => {
    if (!contactCreateModalStore.alert) return null

    return (
      <Alert item={contactCreateModalStore.alert} onClose={contactCreateModalStore.resetAlert} />
    )
  }
)
